import {
  baseContainer,
  interactiveContainer,
  neutralText,
  notApplicableText,
} from "../styles_vanilla.css";
import {
  manualMatchText,
  rightMatchContainer,
  pendingUpdateContainer,
  addPaymentDefaultContainer,
  addPaymentDefaultText,
  addPaymentDisabledContainer,
  addPaymentDisabledText,
} from "./styles_vanilla.css";
import {
  DEFAULT_PAYMENT_BENEFICIARY_CONTENT,
  PaymentBeneficiaryStatusType,
  StatusConfig,
} from "./types";

export const STATUS_CONFIG: Record<PaymentBeneficiaryStatusType, StatusConfig> = {
  "manual-match": {
    containerClass: `${baseContainer} ${interactiveContainer}`,
    text: { className: manualMatchText },
    showViewLink: true,
    showInitialIcon: false,
  },
  "manual-match-hide-view": {
    containerClass: `${baseContainer} ${interactiveContainer}`,
    text: { className: manualMatchText },
    showViewLink: false,
    showInitialIcon: false,
  },
  "auto-match": {
    containerClass: `${baseContainer} ${interactiveContainer}`,
    text: { className: neutralText },
    showViewLink: true,
    showInitialIcon: true,
    initialIconType: "bolt",
    initialIconVariant: "solid",
  },
  "right-match": {
    containerClass: `${baseContainer} ${rightMatchContainer}`,
    text: { className: neutralText },
    showInitialIcon: true,
    initialIconType: "user",
    showExternalLink: true,
  },
  "pending-update": {
    containerClass: `${baseContainer} ${pendingUpdateContainer}`,
    text: { className: neutralText },
    showInitialIcon: true,
    initialIconType: "user",
    showExternalLink: true,
    showPendingText: true,
  },
  "add-payment-default": {
    containerClass: `${baseContainer} ${addPaymentDefaultContainer}`,
    text: { className: addPaymentDefaultText },
    showAddIcon: true,
  },
  "add-payment-disabled": {
    containerClass: `${baseContainer} ${addPaymentDisabledContainer}`,
    text: { className: addPaymentDisabledText },
    showAddIcon: true,
  },
  "not-applicable": {
    containerClass: baseContainer,
    text: {
      content: "--",
      className: notApplicableText,
    },
  },
} as const;

export const DEFAULT_CONTENT = DEFAULT_PAYMENT_BENEFICIARY_CONTENT;
